import { useSubscriptionContext } from '../../../contexts/SubscriptionContext';
import { formatCurrency } from '../../../utils/subscriptionUtils';

export const MonthlySummaryCard = () => {
    const { monthlySummary, isCoreActive } = useSubscriptionContext();

    if (!isCoreActive) {
        return (
            <div className="monthly-summary-card">
                <h4 className="monthly-summary-title">Monthly Summary</h4>
                <p className="monthly-summary-empty">
                    No invoices yet. Your billing history will appear here once you subscribe to the Core Program.
                </p>
            </div>
        );
    }

    return (
        <div className="monthly-summary-card">
            <h4 className="monthly-summary-title">Monthly Summary</h4>
            <div className="monthly-summary-rows">
                <div className="monthly-summary-row">
                    <span>Core Program</span>
                    <span>{formatCurrency(monthlySummary.coreProgram)}</span>
                </div>
                {monthlySummary.addOns.map((addon) => (
                    <div key={addon.label} className="monthly-summary-row">
                        <span>
                            {addon.label}
                            {addon.detail && <span className="monthly-summary-detail"> ({addon.detail})</span>}
                        </span>
                        <span>{formatCurrency(addon.amount)}</span>
                    </div>
                ))}
            </div>
            <div className="monthly-summary-total">
                <span>Total per month</span>
                <span>{formatCurrency(monthlySummary.total)}</span>
            </div>
        </div>
    );
};
